import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import team_kay from "../../img/team_kay.jpg";
import team_yuki from "../../img/team_yuki.jpg";
import ParticlesContainer from '../dashboard/ParticlesContainer';
import { withRouter } from "react-router";

const jumbotronStyle = {
    paddingBottom: '60px',
    paddingTop: '80px',
    boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",
    position: "relative",
    zIndex: "999",
}

const insideStyle = {
    position: "relative",
    zIndex: "999009",
}

class Team extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div className="grey lighten-5" >

                <div className="card-panel white-text teal lighten-1" style={jumbotronStyle}>
                    <ParticlesContainer>
                    </ParticlesContainer>
                    <div className="container white-text" style={insideStyle}>
                        <h4>OUR VISION</h4>
                    </div>


                </div>

                <div className="mainpage container z-depth-0 ">
                    <div className="row"></div>


                    {/* space */}
                    <div className="row">
                        <p>We empower entrepreneurs and freelancers by providing tools on the decentralised platform, to protect and scale business fast and globally.</p>
                        <p>In the modern work environment, we simplify complex tasks easier legal contract easier, and more secure from fabrication.</p>
                        <p>Do more what you Love, we take the rest.</p>

                Cusaly makes business contract easy for everyone who co-creates value and scale fast in the collaborative business environment.
            
                    </div>
            <div className="row">
                <div className="col s4 m4">
                    <div className="card small">
                        <div className="card-image waves-effect waves-block waves-light">
                            <img className="activator" alt="team_kay" src={team_kay} />
                        </div>
                        <div className="card-content">
                            <span className="card-title activator grey-text text-darken-4">Kay Yano<i className="material-icons right">more_vert</i></span>
                        </div>
                        <div className="card-reveal">
                            <span className="card-title grey-text text-darken-4">Kay Yano<i className="material-icons right">close</i></span>
                            <p>CEO / Business Lead, Master of enterprise business & partnership Ex−Google, IE MBA, Based in Berlin.</p>
                            <p><a href="https://www.linkedin.com/in/keiichiroyano/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={['fab', 'linkedin']} size="lg" /></a></p>
                        </div>
                    </div>
                </div>
                <div className="col s4 m4">
                    <div className="card small">
                        <div className="card-image waves-effect waves-block waves-light">
                            <img className="activator" alt="team_yuki" src={team_yuki} />
                        </div>
                        <div className="card-content">
                            <span className="card-title activator grey-text text-darken-4">Yuki Katoh<i className="material-icons right">more_vert</i></span>
                        </div>
                        <div className="card-reveal">
                            <span className="card-title grey-text text-darken-4">Yuki Katoh<i className="material-icons right">close</i></span>
                            <p>CTO / Tech lead nachine learning, AI, big Data, blockchain in health, transportation, finance and online business. Ex-Rocket Internet. </p>
                            <p><a href="https://www.linkedin.com/in/yukiegosapporo/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={['fab', 'linkedin']} size="lg" /></a></p>
                        </div>
                    </div>
                </div>


            </div>

                    {/* space */ }

        <div className="row">
        </div>
                </div >
            </div >
        )
    }
}

export default withRouter(Team);